<div class="pin-modal">

  <nz-radio-group *ngIf="pinData?.data?.id" class="tab-group" [(ngModel)]="segment"
    (ngModelChange)="segmentChange($event)" nzButtonStyle="solid">
    <label nz-radio-button [nzValue]="'info'">
      <span nz-icon nzType="info-circle" nzTheme="outline"></span>
    </label>
    <label nz-radio-button [nzValue]="'logs'">
      <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
    </label>
  </nz-radio-group>

  <div class="address-block" *ngIf="segment == 'info'">
    <div class="address-text">{{ address || data?.address }}</div>
    <button nz-button nzType="text" nzSize="small" class="copy-btn" (click)="copyAddress()"
      [nzTitle]="addressCopied ? 'Copied!' : 'Copy address'">
      <span nz-icon [nzType]="addressCopied ? 'check' : 'copy'" nzTheme="outline"></span>
      {{ addressCopied ? 'Copied' : 'Copy' }}
    </button>
  </div>

  <form *ngIf="segment == 'info'" [formGroup]="leadForm" nz-form [nzLayout]="'vertical'" class="form-section">
    <form [formGroup]="dispForm">
      <nz-form-item>
        <nz-form-label [nzFor]="'disposition'" nzRequired>Disposition</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="disposition" id="disposition" nzPlaceHolder="Select pin disposition"
            [nzShowSearch]="true" [nzAllowClear]="true">
            <nz-option *ngFor="let disp of dispositions" [nzValue]="disp" [nzLabel]="disp.disposition"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>

    <nz-form-item *ngIf="!pinData?.data?.id && data?.mdu">
      <nz-form-label nzRequired [nzFor]="'street_line_2'">Address Line 2</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="street_line_2" id="street_line_2" placeholder="Apt 1"/>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzFor]="'first'">First Name</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="first" id="first" placeholder="John" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzFor]="'last'">Last Name</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="last" id="last" placeholder="Doe" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzFor]="'phone'">Phone Number</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="phone" id="phone" mask="(000) 000-0000" />
      </nz-form-control>
    </nz-form-item>

    <!-- <nz-form-item>
      <nz-form-label [nzFor]="'email'">Email</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="email" id="email" type="email" placeholder="john.doe@email.com" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzFor]="'dob'">Date of Birth</nz-form-label>
      <nz-form-control>
        <nz-date-picker formControlName="dob" id="dob" [nzDisabledDate]="disableFutureDates" placeholder="Select date">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item> -->

    <ng-container *ngIf="showCustomFields">
      <nz-form-item *ngFor="let field of customFieldDefs">
        <nz-form-label [nzFor]="'custom_' + field.name">{{ field.custom_field?.name }}</nz-form-label>
        <nz-form-control>
          <input *ngIf="field.custom_field?.type === 'input'" nz-input
            [(ngModel)]="customFieldValues[field.custom_field.name]" [name]="'custom_' + field.custom_field.name"
            [ngModelOptions]="{standalone: true}" [placeholder]="field.custom_field?.name" />
          <nz-date-picker *ngIf="field.custom_field?.type === 'date'"
            [(ngModel)]="customFieldValues[field.custom_field.name]" [name]="'custom_' + field.custom_field.name"
            [ngModelOptions]="{standalone: true}" placeholder="Select date" style="width: 100%;">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </form>

  <div *ngIf="segment === 'info'" class="notes-section">
    <form [formGroup]="noteForm">
      <nz-form-item>
        <nz-form-label [nzFor]="'note'">New Note</nz-form-label>
        <nz-form-control>
          <textarea nz-input id="note" formControlName="note" rows="3" placeholder="Enter note..."></textarea>
        </nz-form-control>
      </nz-form-item>
    </form>
    <!-- <button nz-button [disabled]="noteForm.invalid" nzType="primary" class="btn-full btn-save" (click)="saveNote()">Save
      Note</button> -->

    <div *ngIf="latestUserNote" class="latest-note">
      <div class="latest-note-title">Latest note</div>
      <p class="latest-note-text">{{ latestUserNote.note }}</p>
      <span class="latest-note-meta">{{ latestUserNote.user }} · {{ latestUserNote.date | date:'short' }}</span>
    </div>
  </div>

  <ng-container *ngIf="segment === 'logs'">
    <!-- <form [formGroup]="noteForm" class="notes-section">
      <nz-form-item>
        <nz-form-label [nzFor]="'note'">New Note</nz-form-label>
        <nz-form-control>
          <textarea nz-input id="note" formControlName="note" rows="4" placeholder="Enter note..."></textarea>
        </nz-form-control>
      </nz-form-item>
    </form>
    <button nz-button *ngIf="segment === 'logs'" [disabled]="noteForm.invalid" nzType="primary"
      class="btn-full btn-save" (click)="saveNote()">Save Note</button> -->

    <nz-list *ngIf="segment == 'logs'" nzItemLayout="horizontal" class="history-list">
      <nz-list-item *ngFor="let item of pin_history">
        <nz-list-item-meta [nzDescription]="item.user + ' ' + (item.date | date:'short')">
          <nz-list-item-meta-title>
            {{ item.note }}
            <nz-tag *ngIf="(item.history_type || 'user added') === 'system'" nzColor="default"
              class="history-tag">System</nz-tag>
            <nz-tag *ngIf="(item.history_type || 'user added') === 'user added'" nzColor="blue"
              class="history-tag">User</nz-tag>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
      </nz-list-item>
    </nz-list>
  </ng-container>

    <button nz-button nzType="primary" *ngIf="segment === 'info'" (click)="determineSaveType()" class="btn-full btn-save">Save</button>
  <button nz-button nzType="default" (click)="cancel()" class="btn-full btn-close">Close</button>

</div>